<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">



  <!-- Header -->
  <div
    class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">

    <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
      <button (click)="exit()" type="button" class="btn-fab-secondary">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </svg>
      </button>

      <div class="">
        <div class="inline-flex items-center gap-x-2">
          <h3 class="text-md font-semibold text-primary">Create Brief
          </h3>
          <!-- <span
            class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset">Text</span> -->
        </div>
        <p class="mt-0 text-xs text-secondary">Content Review</p>
      </div>
    </div>

    <div class="flex flex-row items-center justify-end gap-x-4">
      @if (screen() !== 'chooser') {
      <button type="button" class="secondary-button" (click)="switchFlow()">Switch flow</button>
      }
    </div>

  </div>
  <!-- Header - END-->

  <!-- Main Section -->
  <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
    @switch (screen()) {
    @case ('chooser') {
    <bb-flow-chooser (choose)="chooseFlow($event)" />
    }
    @case ('wizard') {
    <bb-wizard-flow class="block h-full" (launch)="submit()" />
    }
    @case ('ai') {
    <bb-ai-first-flow class="block h-full" (launch)="submit()" (startOver)="startOver()" />
    }
    }
  </div>
  <!-- Main Section - END -->

</div>

@if (createBriefService.progress_indicator() > 0) {
<atom-loading-overlay-progress (cycleComplete)="onLaunchAnimationComplete()" />
}